import { h } from 'preact';
import * as BaseComp from 'components/bolt/header/header.js';
import NeonHeader from 'components/bolt/neonHeader/neonHeader.js';

import { findInVNode } from 'utils/vnode';

import s from 'components/bolt/header/header.sss';

export default class Header extends BaseComp.default {
	render(props, state) {
		const baseJSX = super.render(props, state);
		const headerContainer = findInVNode(baseJSX, `.${s.headerContainer}`);
		headerContainer?.children.unshift(<NeonHeader {...props} />);
		return baseJSX;
	}
}
